import Head from "next/head";
import BreadcrumbScroll from "../../../components/Elements/BreadcrumbScroll/BreadcrumbScroll";
import ServerError from "../../../components/Elements/ServerError/ServerError";
import SingleVideoContent from "../../../components/VideosCompo/SingleVideoContent/SingleVideoContent";
import { slugGenerator } from "../../../lib/slugGenerator";
import RelatedRow from "../../../components/Elements/RelatedRow/RelatedRow";
import { jDateFormatter } from "../../../lib/dateFormater";

const SingleVideoPage = ({
  videoData: jsonVideoData,
  relatedVideoData: jsonRelatedVideoData,
}) => {
  const videoData = JSON.parse(jsonVideoData);
  const relatedVideos = JSON.parse(jsonRelatedVideoData);

  return (
    <>
      {videoData !== null ? (
        <>
          <Head>
            <title>{`${videoData?.title} - پلتفرم ویدیو`}</title>
            <meta
              name="viewport"
              content="initial-scale=1.0, width=device-width"
            />
            <meta charSet="utf-8" />
            <meta name="description" content={videoData?.description} />
            <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
            <meta
              name="robots"
              content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
            />
            <link
              rel="canonical"
              href={`https://about.digikala.com/videos/vod-${
                videoData?.id
              }/${slugGenerator(videoData?.title)}`}
            />
            <meta property="og:locale" content="fa_IR" />
            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content={`${videoData?.title} - پلتفرم ویدیو`}
            />
            <meta
              property="og:url"
              content={`https://about.digikala.com/videos/vod-${
                videoData?.id
              }/${slugGenerator(videoData?.title)}`}
            />
            <meta property="og:site_name" content="پلتفرم ویدیو" />
            <meta
              property="og:image"
              itemProp="image"
              content={videoData?.thumbnail_img}
            />
            <meta property="og:image:width" content="900" />
            <meta property="og:image:height" content="600" />
            <meta
              property="og:image:alt"
              content={`${videoData?.title} - پلتفرم ویدیو`}
            />
            <meta property="og:image:type" content="image/png" />
            <meta
              property="og:site_name"
              content="پلتفرم ویدیو"
              key="ogsitename"
            />
            <meta
              property="og:title"
              content={`${videoData?.title} - پلتفرم ویدیو`}
              key="ogtitle"
            />
            <meta
              property="og:description"
              content={videoData?.description}
              key="ogdesc"
            />
            <meta name="twitter:card" content="summary_large_image" />
            <meta
              name="twitter:title"
              content={`${videoData?.title} - پلتفرم ویدیو`}
            />
            <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
            <meta name="twitter:image" content={videoData?.thumbnail_img} />
            <meta name="twitter:description" content={videoData?.description} />
          </Head>
          <BreadcrumbScroll
            title={videoData.title}
            routeOne="/videos"
            titleOne="پلتفرم ویدیو"
            routeTwo={`/videos/vod-${videoData.id}/${slugGenerator(
              videoData?.title
            )}`}
            titleTow={videoData.title}
          />
          <SingleVideoContent data={videoData} />

          {relatedVideos?.results?.filter((i) => i.id !== videoData.id).length >
            0 && (
            <RelatedRow
              title="ویدیوها مرتبط"
              rowData={
                relatedVideos?.results?.filter((i) => i.id !== videoData.id)
                  .length > 0
                  ? relatedVideos?.results
                      ?.filter((i) => i.id !== videoData.id)
                      ?.map((item) => ({
                        img: item.thumbnail_img,
                        imgAlt: item.title,
                        title: item.title,
                        cat: item.category.title,
                        date: jDateFormatter(item?.date_published),
                        duration: item.duration?.replace("00:", ""),
                        link: `vod-${item.id}/${slugGenerator(item?.title)}`,
                      }))
                  : []
              }
              rowTitle="ویدیوها"
              allItemsLink="/videos"
            />
          )}
        </>
      ) : (
        <ServerError />
      )}
    </>
  );
};

export default SingleVideoPage;

export async function getServerSideProps(context) {
  const videoId = String(String(context.query.videoSlug[0]).substring(4) || "");
  if (!videoId) {
    return {
      redirect: {
        permanent: false,
        destination: "/404",
      },
      props: {},
    };
  }

  try {
    const videoRes = await fetch(
      `${
        process.env.ABOUT_API_BASE_URL
      }/api/v1/videos/${videoId}?reqDate=${Date.now()}&is_published=true&language=FA`
    );
    const videoData = await videoRes.json();

    const tag = videoData?.tags[0]?.id;

    const relatedVideoRes = await fetch(
      `${
        process.env.ABOUT_API_BASE_URL
      }/api/v1/videos?tags=${tag}&reqDate=${Date.now()}&is_published=true&language=FA`
    );
    const relatedVideoData = await relatedVideoRes.json();

    if (videoRes.status === 404) {
      return {
        notFound: true, //redirects to 404 page
      };
    }
    return {
      props: {
        videoData: JSON.stringify(videoData),
        relatedVideoData: JSON.stringify(relatedVideoData),
      },
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        videoData: null,
        relatedVideoData: null,
      },
    };
  }
}
